// extracted by mini-css-extract-plugin
export default {"error":"edit__error__lZ"};